export const LOCAL_HOST_DOMAIN = 'http://localhost:8000';
